import {GET} from '../constants/API_CONSTANTS';
import {API_GET_MERCHANTS_FROM_CONFIGURATION_SERVICE} from '../constants/API_ENDPOINTS';
import {request} from '../utils/request';

export const getMerchantsApi = async (search) => {
  return request(GET, API_GET_MERCHANTS_FROM_CONFIGURATION_SERVICE(search));
};

export default getMerchantsApi;
